import { useDrawer } from '@cast/design-system';

import { PodListDrawer, type PodListDrawerBaseProps } from './PodListDrawer';

export const usePodListDrawer = () => {
  const { open } = useDrawer();

  return {
    openPodListDrawer: (props: PodListDrawerBaseProps) => {
      open({ component: PodListDrawer, props });
    },
  };
};
